<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/qunlong/first/inspection/pageWoList" getKey="rows" :pageSizes="pageSizes" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
						<el-input v-model="yt.conditions.searchText"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, beforeReq, afterReq)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ statusList: ['2', '3', '4'], orderBy: 'priority asc' }, beforeReq, afterReq)">
              {{ $t('chongzhi') }}
            </el-button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" type="primary" @click="moveUp" :disabled="selectIds.length !== 1" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')">
          {{ $t('shangyi') }}
        </el-button>
        <el-button size="mini" type="primary" @click="moveDown" :disabled="selectIds.length !== 1" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')">
          {{ $t('xiayi') }}
        </el-button>
        <el-button size="mini" type="default" @click="moveFirst" :disabled="selectIds.length !== 1" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')">
          {{ $t('zuishang') }}
        </el-button>
        <el-button size="mini" type="default" @click="moveLast" :disabled="selectIds.length !== 1" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')">
          {{ $t('zuixia') }}
        </el-button>
      </template>
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope"> </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
// import work_bom from '@@/pages/web/order_management/erp/work_bom'
export default {
  name: 'report_plan_report_single_adjust',
  components: {
    // work_bom
  },
  data() {
    return {
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'dingdanfenluID',
          prop: 'plan.orderEntryId'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name'
        },
        {
          label: 'huohao',
          prop: 'plan.articleNumber'
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'dingdanzhongliang(KG)',
          prop: 'weight'
        },
        {
          label: 'danzhong(G)',
          prop: 'singleWeight'
        },
        {
          label: 'shijimoqiangshu',
          prop: 'actualCavity'
        },
        {
          label: 'biaozhun/shijizhouqi(miao)',
          prop: 'standardCycle_actualCycle'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'gongdanpaixu',
          prop: 'priority'
        },
        {
          label: 'gongdanzhuangtai',
          type: 'tag',
          prop: 'status',
          width: 130,
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shougongxuwangong')
            },
            6: {
              color: '#67C23A',
              text: this.$t('wangong')
            },
            7: {
              color: '#909399',
              text: this.$t('guanbi')
            },
            8: {
              color: '#E6A23C',
              text: this.$t('yidiaobo')
            }
          }
        }
      ],
      selectIds: [],
      pageSizes: [20, 50, 100]
    };
  },

  created() {
    setTimeout(() => {
      this.yt.pageSize = 20;
      this.yt.conditions = {
        statusList: ['2', '3', '4'],
        orderBy: 'priority asc'
      };
      this.yt.get(1, this.beforeReq, this.afterReq);
    }, 300);
  },
  watch: {
    'yt.list': {
      handler(n) {
        this.$emit('list-change', n);
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    selectionChange(items) {
      if (items.length > 1) {
        if (items[1].status === 3) {
          this.yt.list.forEach(row => {
            if (row['id'] === items[1]['id']) {
              this.yt.$refs.table.toggleRowSelection(row, false);
            }
          });
          items.splice(1, 1);
        } else {
          this.yt.list.forEach(row => {
            if (row['id'] === items[0]['id']) {
              this.yt.$refs.table.toggleRowSelection(row, false);
            }
          });
          items.splice(0, 1);
        }
      } else if (items.length === 1 && items[0].status === 3) {
        this.yt.list.forEach(row => {
          if (row['id'] === items[0]['id']) {
            this.yt.$refs.table.toggleRowSelection(row, false);
          }
        });
        items = [];
      }
      this.selectIds = items.map(i => {
        return i['id'];
      });
    },
    beforeReq(params) {
      return params;
    },
    afterReq(result) {
      setTimeout(() => {
        let list = this.yt.list;
        if (list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            let row = list[i];
            row.standardCycle_actualCycle = (row.standardCycle == null ? '-' : row.standardCycle) + '/' + (row.actualCycle == null ? '-' : row.actualCycle);

            if (this.yt.conditions.searchText && this.yt.conditions.searchText != '') {
              row.priority = i + 1;
            }
          }
        }
      }, 300);
      return result;
    },
    moveUp() {
      if (this.selectIds.length === 1) {
        let list = this.yt.list;
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item['id'] === this.selectIds[0]) {
            if (i === 0) {
              return;
            } else if (list[i - 1].status === 3) {
              return;
            } else {
              let temp = list[i - 1];
              temp.priority = temp.priority + 1;
              item.priority = item.priority - 1;
              list[i - 1] = item;
              list[i] = temp;
              if (list[i - 1].priority <= 0) {
                let n = 1 - list[i - 1].priority;
                list[i - 1].priority = 1;
                list[i].priority = list[i].priority - 1;
                for (let j = i; j < list.length; j++) {
                  list[j].priority = list[j].priority + n;
                }
              }
            }
            this.$set(this.yt, 'list', list);
            this.yt.$forceUpdate();
            return;
          }
        }
      }
    },
    moveDown() {
      if (this.selectIds.length === 1) {
        let list = this.yt.list;
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item['id'] === this.selectIds[0]) {
            if (i === list.length - 1) {
              return;
            } else {
              let temp = list[i + 1];
              temp.priority = temp.priority - 1;
              item.priority = item.priority + 1;
              list[i + 1] = item;
              list[i] = temp;
            }
            this.$set(this.yt, 'list', list);
            this.yt.$forceUpdate();
            return;
          }
        }
      }
    },
    moveFirst() {
      if (this.selectIds.length === 1) {
        let list = this.yt.list;
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item['id'] === this.selectIds[0]) {
            if (i === 0) {
              return;
            } else {
              let temp = list[i];
              temp.priority = list[0].priority;
              for (let j = i; j > 0; j--) {
                list[j] = list[j - 1];
                list[j].priority = list[j].priority + 1;
              }
              list[0] = temp;
            }
            this.$set(this.yt, 'list', list);
            this.yt.$forceUpdate();
            return;
          }
        }
      }
    },
    moveLast() {
      if (this.selectIds.length === 1) {
        let list = this.yt.list;
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item['id'] === this.selectIds[0]) {
            if (i === list.length - 1) {
              return;
            } else {
              let temp = list[i];
              for (let j = i; j < list.length - 1; j++) {
                list[j] = list[j + 1];
                list[j].priority = list[j].priority - 1;
              }
              temp.priority = list[list.length - 1].priority + 1;
              list[list.length - 1] = temp;
            }
            this.$set(this.yt, 'list', list);
            this.yt.$forceUpdate();
            return;
          }
        }
      }
    }
  }
};
</script>
